/**
 * Textos (`en`) del tall «nonconformities» de Qualitat i APPCC (OBR-169). Tall propi: no es toca `en.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const nonConformitiesEn = {
  'backoffice.nonConformities': {
    subtitle: 'A single register of non-conformities and their corrective actions',
    newNonConformity: 'New non-conformity',

    // List and filters
    searchLabel: 'Search',
    searchPlaceholder: 'Code, description, supplier, article or lot',
    filterStatusLabel: 'Status',
    filterStatusActive: 'Active',
    filterStatusAll: 'All',
    filterOriginLabel: 'Origin',
    filterOriginAll: 'All origins',
    filterFromLabel: 'From',
    filterToLabel: 'To',
    clearFilters: 'Clear filters',
    loadError: 'The non-conformities could not be loaded',
    empty: 'There are no non-conformities yet.',
    emptyActive: 'There are no active non-conformities. All in order.',
    emptyFiltered: 'No non-conformity matches the filters.',

    // Statuses and origins
    statusOpen: 'Open',
    statusInProgress: 'In progress',
    statusClosed: 'Closed',
    originReception: 'Reception',
    originSelfCheck: 'Self-check',
    originProduction: 'Production',
    originManual: 'Manual',
    originOther: 'Other',

    // Card
    occurredAtLabel: 'When',
    reportedByLabel: 'Reported by',
    unknownUser: 'Unknown person',
    automaticNoDetail: 'Opened automatically, no further detail.',
    actionsProgress: '{{closed}} of {{total}} actions closed',
    actionsNone: 'No corrective actions',
    actionsOverdue_one: '{{count}} action overdue',
    actionsOverdue_other: '{{count}} actions overdue',
    openDetail: 'Open',

    // Links
    linkSupplier: 'Supplier',
    linkArticle: 'Article',
    linkSupplierLot: 'Supplier lot',
    linkFinishedLot: 'Produced lot',
    linkReception: 'Delivery note',
    linkIncident: 'Incident',
    linkSelfCheck: 'Self-check',
    linkIncidentOpen: 'View the incident',
    linkSelfCheckOpen: 'View the self-checks',
    supplierLotCodeRef: 'supplier lot {{code}}',

    // Detail
    sectionSummary: 'What happened',
    sectionLinks: 'Origin',
    sectionAttachment: 'Photo or document',
    sectionActions: 'Corrective actions',
    sectionHistory: 'History',
    occurredAt: 'Date and time',
    reportedBy: 'Reported by',
    closedBanner: 'Closed on {{date}} by {{name}}: {{note}}',
    openAttachment: 'Open the file',
    attachmentError: 'The file could not be opened.',
    readOnlyHint: 'Only administration, quality and production can change it.',

    // Status changes
    moveToInProgress: 'Set in progress',
    moveToOpen: 'Back to open',
    closeNonConformity: 'Close the non-conformity',
    reopenNonConformity: 'Reopen the non-conformity',
    closeBlockedActions_one: 'To close it, {{count}} corrective action must be closed first.',
    closeBlockedActions_other: 'To close it, {{count}} corrective actions must be closed first.',
    closeTitle: 'Close the non-conformity',
    closeBody: 'A closed non-conformity, with its actions, cannot be touched until it is reopened.',
    closeNoteLabel: 'Closing note',
    closeNotePlaceholder: 'What was done and why it is considered resolved',
    closeConfirm: 'Close',
    reopenTitle: 'Reopen the non-conformity',
    reopenBody: 'It is open again and can be worked on. The reason is kept in the history.',
    reopenNoteLabel: 'Reason',
    reopenNotePlaceholder: 'Why it is being reopened',
    reopenConfirm: 'Reopen',

    // Corrective actions
    addAction: 'Add an action',
    actionsEmpty: 'There are no corrective actions yet.',
    actionsLockedHint: 'Reopen the non-conformity to add or change actions.',
    actionNewTitle: 'New corrective action',
    actionEditTitle: 'Edit the corrective action',
    actionDescriptionLabel: 'What has to be done',
    actionDescriptionPlaceholder: 'For example: clean and disinfect the cold room',
    actionResponsibleLabel: 'Responsible',
    actionNoResponsible: 'No one responsible',
    actionDueOnLabel: 'Due date',
    actionAddConfirm: 'Add',
    actionSaveConfirm: 'Save',
    editAction: 'Edit',
    startAction: 'Set in progress',
    backToOpenAction: 'Back to open',
    closeAction: 'Close the action',
    reopenAction: 'Reopen the action',
    actionStatusOpen: 'Open',
    actionStatusInProgress: 'In progress',
    actionStatusClosed: 'Closed',
    actionOverdue: 'Overdue',
    actionResponsibleLine: 'Responsible: {{name}}',
    actionDueLine: 'Due date: {{date}}',
    actionVerifiedLine: 'Verified by {{name}} on {{date}}',
    actionVerificationLine: 'Verification: {{note}}',
    verifyTitle: 'Close the corrective action',
    verifyBody: 'To mark it as done, record what was checked. It stays in the history.',
    verifyLabel: 'Verification',
    verifyPlaceholder: 'What was checked',
    verifyConfirm: 'Close the action',

    // History
    historyEmpty: 'There are no movements yet.',
    eventCreated: 'Reported',
    eventStatusChanged: 'Status: {{from}} → {{to}}',
    eventActionAdded: 'Action added: {{note}}',
    eventActionUpdated: 'Action changed: {{note}}',
    eventActionMoved: 'Action: {{from}} → {{to}}. {{note}}',
    eventClosed: 'Closed: {{note}}',
    eventReopened: 'Reopened: {{note}}',
    eventByLine: '{{name}} · {{date}}',

    // Manual non-conformity form
    manualTitle: 'New non-conformity',
    manualBody:
      'Report a non-conformity you have seen. It is created open and the system assigns its code.',
    manualDescriptionLabel: 'What happened',
    manualDescriptionPlaceholder: 'For example: flour received with a torn sack',
    manualSupplierLabel: 'Supplier (optional)',
    manualArticleLabel: 'Article (optional)',
    manualLotLabel: 'Supplier lot (optional)',
    manualLotPickArticle: 'Choose the article first to see its lots.',
    manualLotNone: 'No lot',
    manualLotNoLots: 'This article has no incoming lot yet.',
    manualLotLoadError: 'The lots could not be loaded.',
    manualAttachmentLabel: 'Photo or document (optional)',
    manualAttachmentChoose: 'Choose a file',
    manualAttachmentHint: 'JPEG, PNG or PDF, up to 10 MB.',
    manualAttachmentRemove: 'Remove the file',
    manualCreateConfirm: 'Create',
    searchSupplier: 'Search for a supplier',
    noSupplierMatches: 'No supplier matches',
    searchArticle: 'Search for an article',
    noArticleMatches: 'No article matches',
    noneOption: '—',

    // Validation and server errors
    validationDescriptionRequired: 'Write what happened.',
    validationActionDescriptionRequired: 'Write what has to be done.',
    errorGeneric: 'The change could not be saved. Please try again.',
    errorForbidden: 'You do not have permission to make this change.',
    errorNotFound: 'This non-conformity no longer exists.',
    errorAlreadyClosed: 'Someone else has already closed this non-conformity.',
    errorNotClosed: 'This non-conformity is not closed.',
    errorOpenActions: 'There are still corrective actions that are not closed.',
    errorNoteRequired: 'A note is required.',
    errorVerificationRequired: 'To close the action, say what was checked.',
    errorDescriptionRequired: 'A description is required.',
    errorClosedLocked: 'The non-conformity is closed: reopen it to touch its actions.',
    errorResponsibleOnlyStatus:
      'The responsible person can only change the status and the verification of the action.',
    errorUploadInvalidType: 'The file must be a JPEG, PNG or PDF.',
    errorUploadTooLarge: 'The file is larger than 10 MB.',
    errorUploadFailed: 'The file could not be uploaded. Check the connection and try again.',

    // Summary of an automatic non-conformity (reception)
    reasonTemperatureRange: 'Temperature of {{temperature}} ºC out of range ({{min}} to {{max}} ºC)',
    reasonTemperatureAbove: 'Temperature of {{temperature}} ºC above the maximum ({{max}} ºC)',
    reasonTemperatureBelow: 'Temperature of {{temperature}} ºC below the minimum ({{min}} ºC)',
    reasonTemperature: 'Temperature of {{temperature}} ºC out of range',
    reasonTemperatureUnknown: 'Temperature out of range',
    reasonPackagingKo: 'Packaging not conforming',
    reasonLabelingKo: 'Labelling not conforming',
    reasonDecisionRejected: 'Rejected at the reception check',
    reasonDecisionAcceptedWithIncident: 'Accepted with an incident',
    reasonSelfCheckFailed: 'Self-check not passed',
    reasonUnknown: 'Reason: {{code}}',
    // Summary of a self-check non-conformity
    selfCheckFailedRange: '{{label}}: {{value}} (range {{min}} to {{max}})',
    selfCheckFailedBelowMin: '{{label}}: {{value}} (minimum {{min}})',
    selfCheckFailedAboveMax: '{{label}}: {{value}} (maximum {{max}})',
    selfCheckFailedValue: '{{label}}: {{value}}',
    selfCheckFailedKo: '{{label}}: KO',
    selfCheckFailedUnnamed: 'A self-check point did not pass',
  },
} as const;
